
import { Component, Vue } from "vue-property-decorator";

import { IRouteMeta } from "@/router/interface";
import unit_routes from "@/api/routes/units";

import { EAdmissionPermission } from "@/models/admission/permission";

export interface IChangeArchiveTesting {
  id: string;
  index: number;
  title: string;
  is_archived: boolean;
}

@Component({
  name: "CTestingsChangeArchiveTesting"
})
export default class CTestingsChangeArchiveTesting extends Vue {
  private watchers: Function[] = [];

  public testing: IChangeArchiveTesting | null = null;

  protected beforeDestroy() {
    this.watchers.forEach(unwatch => {
      unwatch();
    });
  }

  protected created() {
    this.watchers.push(
      this.$store.watch(
        state => state.changingArchiveTestingProgram,
        (changingArchiveTestingProgram: IChangeArchiveTesting | null) => {
          this.testing = changingArchiveTestingProgram;

          if (this.testing) {
            this.showModal();
          }
        }
      )
    );
  }

  public async archiveTesting() {
    if (!this.testing) {
      return;
    }

    return this.$api
      .post(
        unit_routes.version_toggle_archived(this.testing.id),
        {},
        {
          params: {
            section_id: (this.$router.currentRoute.meta! as IRouteMeta)
              .permissions?.[0]
          }
        }
      )
      .then(({ data: res }: { data: { is_archived: boolean } }) => {
        this.$store.commit("changedArchiveTestingProgram", {
          ...this.testing,
          is_archived: res.is_archived
        });

        this.hideModal();

        let success_msg = "Тестирование отправлено в архив";

        if (!res.is_archived) {
          success_msg = "Тестирование восстановлено из архива";
        }

        this.$notify({
          group: "notifications",
          type: "success",
          text: success_msg,
          speed: 500
        });
      })
      .catch(({ response: res }) => {
        this.$notify({
          group: "notifications",
          type: "error",
          text: res.data.error,
          speed: 500
        });
      });
  }

  public showModal() {
    this.$modal.show("change_archive_testing_modal");
  }

  public hideModal() {
    this.$modal.hide("change_archive_testing_modal");

    this.$store.commit("changingArchiveTestingProgram", null);
  }

  public allowWrite() {
    return this.$api.hasWritePermissions(
      [EAdmissionPermission.TESTINGS, EAdmissionPermission.EDUCATION_PROGRAMS],
      false
    );
  }
}
